// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export const getStatsTableData = (venue_id,name,game_type_id,start_date,end_date) => {
  var url = `${getLocationOrigin()}/${appConfig.statsTable.data.API}/?report_id=${appConfig.statsTable.data.tables[name]}&venue_id=${venue_id}&game_type_id=${game_type_id}`;
  if(start_date){
    url = url + '&date=' + start_date
  }
  if(end_date){
    url = url + '&end_date=' + end_date
  }
  const options = {...defaultOptions};
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};




// WEBPACK FOOTER //
// ./src/app/services/API/statsTable.js